// extracted by mini-css-extract-plugin
export default {"container":"ClientsListLetterNavigation_container__LwNfQ","item":"ClientsListLetterNavigation_item__prY1d"};